import { initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import {
  getAuth,
  connectAuthEmulator
  // signInWithCredential,
  // EmailAuthProvider
} from 'firebase/auth'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyAzU9VCD1h6Rwl6bsCOzrm6SIJ3ifF8HfQ',
  authDomain: 'slacktidediving.com',
  projectId: 'godiving-a9bd1',
  storageBucket: 'godiving-a9bd1.firebasestorage.app',
  messagingSenderId: '305382194853',
  appId: '1:305382194853:web:f372db436433dae7e0574c',
  measurementId: 'G-208VHWKNT1'
}

const initFirebase = async () => {
  try {
    const app = initializeApp(firebaseConfig)
    const firestore = getFirestore(app)
    const auth = getAuth(app)

    if (import.meta.env.DEV) {
      connectAuthEmulator(auth, 'http://localhost:9099')
      connectFirestoreEmulator(firestore, 'localhost', 8080)
      const storage = getStorage(app)
      connectStorageEmulator(storage, 'localhost', 9199)
      const functions = getFunctions(app)
      connectFunctionsEmulator(functions, 'localhost', 5001)
      /**
       * The following code logins the user automatically to speed up development.
       * For this to work you first need to create a user and then run the command
       * yarn emulator:export, then import the data when starting the emulator
       * yarn firebase emulators:start --only firestore,auth --import=firestore_mock_data
       */
      // signInWithCredential(
      //   auth,
      //   EmailAuthProvider.credential('john@doe.com', '123123')
      // )
    }
  } catch (err) {
    console.error(err)
    return err
  }
}

export default initFirebase
